import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { AppLoader } from '@components/Core/AppLoader';
import { AddEntityButton } from '@components/Core/AddEntityButton';
import { PageHeader } from '@components/Core/PageHeader';
import BrandTabs from '@components/Core/BrandTabs';
import { Input } from '@inputs/Input';
import PointsTable from '@tables/PointsTable/PointsTable';
import { pointsTranslations } from './translations';
import { PointsTransFields } from './types';

function Points() {
  const { brandId } = useParams();

  const { isFetching, text } = useGetBrandData();

  const { t } = useMyTranslations<PointsTransFields>([pointsTranslations.name]);

  const navigate = useNavigate();

  const useFormMethods = useForm<{ search: string }>();
  const { watch } = useFormMethods;

  return (
    <div className="page-container">
      <PageHeader text={text} />
      <BrandTabs currentTab="point list" />
      <div className="flex flex-row justify-between items-center px-[48px] sm-page-padding gap-x-[24px] max-md:gap-x-[12px]">
        <FormProvider {...useFormMethods}>
          <Input name="search" type="text" placeholder={t('search')} />
        </FormProvider>
        <AddEntityButton
          text={t('addPoint')}
          onClick={() => navigate(`/brands/${brandId}/add-point`)}
        />
      </div>
      {isFetching ? <AppLoader /> : <PointsTable search={watch('search')} />}
    </div>
  );
}

export default Points;
